import { motion } from "framer-motion";
import { CalendarDays, MapPin, Users, ArrowUpRight } from "lucide-react";

const eventos = [
  {
    titulo: "Congreso 50 años de Educación a Distancia en la UTPL",
    fechaInicio: "2026-09-03",
    fecha: "3 y 4 de septiembre de 2026",
    lugar: "Centro de Convenciones UTPL",
    modalidad: "Presencial",
    enlace: "https://www.utpl.edu.ec/congreso-mad",
  },
  {
    titulo: "XIV Congreso Latinoamericano de Plantas Medicinales",
    fechaInicio: "2026-10-14",
    fecha: "14, 15 y 16 de octubre de 2026",
    lugar: "Centro de Convenciones UTPL",
    modalidad: "Presencial",
    enlace: "https://www.utpl.edu.ec/colaplamed",
  },
  {
    titulo: "XLI Jornadas Sudamericanas de Ingeniería Estructural",
    fechaInicio: "2026-11-09",
    fecha: "9, 10 y 11 de noviembre de 2026",
    lugar: "Centro de Convenciones UTPL",
    modalidad: "Presencial",
    enlace: "https://www.utpl.edu.ec/congreso-ingenieria-estructural",
  },

  {
    titulo:
      "International Conference of Engineering, Technology and Architecture  ",
    fechaInicio: "2026-11-09",
    fecha: "9, 10 y 11 de noviembre de 2026",
    lugar: "Centro de Convenciones UTPL, Zoom",
    modalidad: "Presencial, Virtual",
    enlace: "https://www.utpl.edu.ec/congreso-iceta",
  },
  {
    titulo: "V Seminario Iberoamericano de Economía de la Cultura",
    fechaInicio: "2026-11-26",
    fecha: "26 y 27 de noviembre de 2026",
    lugar: "Centro de Convenciones UTPL",
    modalidad: "Presencial",
    enlace: "https://www.utpl.edu.ec/seminario-economia/",
  },
];

const formatFecha = (fecha) => {
  const [, month, day] = fecha.split("-").map(Number);

  const meses = [
    "ENE",
    "FEB",
    "MAR",
    "ABR",
    "MAY",
    "JUN",
    "JUL",
    "AGO",
    "SEP",
    "OCT",
    "NOV",
    "DIC",
  ];

  return {
    dia: day,
    mes: meses[month - 1],
  };
};

export default function Events() {
  const eventosOrdenados = [...eventos].sort((a, b) =>
    a.fechaInicio.localeCompare(b.fechaInicio),
  );

  return (
    <section className="bg-slate-100 py-20">
      <div className="container mx-auto px-6">
        {/* Encabezado */}
        <div className="mb-14 text-center">
          <span className="mb-4 inline-flex rounded-full bg-blue-100 px-4 py-2 text-sm font-medium text-blue-700">
            Agenda 2026
          </span>

          <h2 className="  font-bold  ">Próximos eventos</h2>

          <p>
            Conoce nuestros encuentros académicos, científicos y culturales que
            reunirán a expertos, investigadores y profesionales de distintos
            países.
          </p>
        </div>

        {/* Grid */}
        <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">
          {eventosOrdenados.map((evento, index) => {
            const fecha = formatFecha(evento.fechaInicio);

            return (
              <motion.article
                key={evento.titulo}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.45,
                  delay: index * 0.08,
                }}
                whileHover={{
                  y: -8,
                }}
                className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-blue-100 hover:shadow-xl"
              >
                {/* Barra superior */}
                <div className="h-2 bg-[#004270]" />

                <div className="flex h-full flex-col p-7">
                  {/* Header */}
                  <div className=" flex items-center justify-between">
                    <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-blue-700">
                      {evento.modalidad}
                    </span>

                    <CalendarDays size={22} className="text-blue-700" />
                  </div>

                  {/* Título */}
                  <h3  >
                    {evento.titulo}
                  </h3>

                  {/* Fecha destacada */}
                  <div className="mb-6 rounded-2xl border border-blue-100 bg-gradient-to-r from-blue-50 to-slate-50 p-4">
                    <div className="flex items-center gap-4">
                      <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-2xl bg-[#004270] text-white shadow-lg">
                        <span className="text-3xl font-bold leading-none">
                          {fecha.dia}
                        </span>

                        <span className="mt-1 text-xs font-semibold uppercase tracking-widest">
                          {fecha.mes}
                        </span>
                      </div>

                      <div>
                        <p className="mb-1 text-xs font-bold uppercase tracking-wider text-blue-700">
                          Fecha del evento
                        </p>

                        <p className="text-base font-semibold leading-snug text-slate-900">
                          {evento.fecha}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Información */}
                  <div className="space-y-5">
                    <div className="flex items-start gap-3">
                      <MapPin
                        size={18}
                        className="mt-1 shrink-0 text-blue-700"
                      />

                      <div>
                        <p className="m-0 p-0   text-xs font-semibold uppercase tracking-wide text-slate-400">
                          Lugar
                        </p>

                        <p className="text-sm m-0 p-0   text-slate-700">
                          {evento.lugar}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <Users
                        size={18}
                        className="mt-1 shrink-0 text-blue-700"
                      />

                      <div>
                        <p className="m-0 p-0   text-xs font-semibold uppercase tracking-wide text-slate-400">
                          Modalidad
                        </p>

                        <p className="m-0 p-0 text-sm text-slate-700">
                          {evento.modalidad}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* CTA */}
                  <div className="mt-auto pt-8">
                    <a
                      href={evento.enlace}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 font-medium text-[#004270] transition-all duration-300 hover:gap-3 hover:text-blue-900"
                    >
                      Más información
                      <ArrowUpRight
                        size={18}
                        className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                      />
                    </a>
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
